// stages of the activity
export const REPORT_NEW = "New";
export const REPORT_IN_PROGRESS = "In progress";
export const REPORT_CLOSED = "Closed";
export const REPORT_ARCHIVED = "archived";
